import "./Component3.css";
import { Link } from "react-router-dom";

const Component3 = ({ Data, onCategorySelect }) => {

  if (!Data || Data.length === 0) {
    return null;
  }

  return (
    <section id="Edit-section">
      <div className="container">
        <div className="pransh_name d-flex gap-2 ms-3">
          <span />
          <h6 className=" mt-1">Categories</h6>
        </div>
        <div className="row">
          <div className="row m-0 m-auto">
            <div className="col-12">
              <h2 className="mt-3 mb-3">Browse By Category</h2>
            </div>
          </div>
          <div className="row m-0 m-auto mt-1 mt-lg-1">
            <div className="col-12">
              <div id="categories-owl-demo">
                {Data.map((item) => (
                  <div
                    key={item.categoryId}
                    className="item text-center"
                  >
                    <Link
                      to={item.categoryLink}
                      className="text-decoration-none category-card"
                      onClick={(e) => {
                        e.preventDefault();
                        onCategorySelect && onCategorySelect(item.categoryName);
                      }}
                    >
                      <div className="category-image-wrapper">
                        {item.categoryImage ? (
                          <img src={item.categoryImage} alt={item.categoryName} className="category-image" />
                        ) : (
                          <ion-icon name={item.categoryIcon}></ion-icon>
                        )}
                      </div>
                      <p className="category-name">{item.categoryName}</p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Component3;
